import React, { useState, useEffect, useCallback } from "react";
import _ from "lodash";
import { useMutation } from "@apollo/client";
import {
  Row,
  Col,
  Button,
  Modal,
  Form,
  Alert,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import S3Image from "../base/S3Image";
import ContainerNotResult from "../base/ContainerNotResult";
import { GALERIA_EMPRESA } from "../../utils/graphql_query";
import {
  ADD_IMAGEN_GALERIA_EMPRESA,
  DELETE_IMAGEN_GALERIA_EMPRESA,
} from "../../utils/graphql_mutation";
import { useQuery } from "@apollo/client";
import Errors from "../base/Errors";
import LoadingPage from "../base/LoadingPage";
import { uploadImgS3 } from "../../utils/helpers";
import moment from "moment";

export const trimLastKey = (key) => {
  if (!key) return key;
  return key.split("/").pop();
};

const GaleriaDeImagenes = ({ empresa_id }) => {
  const { data, loading, refetch, error } = useQuery(GALERIA_EMPRESA, {
    variables: { empresa_id: empresa_id },
  });
  const [showModal, setShowModal] = useState(false);
  const [modDelete, setModDelete] = useState(false);
  const [modShowImg, setModShowImg] = useState({
    img: "",
    open: false,
    isOld: false,
  });
  const [ldAccion, setLdAccion] = useState(false);
  const [complet, setComplet] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  const [selectedElement, setselectedElement] = useState(undefined);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [showImg, setShowImg] = useState(null);
  const [isHovered, setHover] = useState({
    visible: false,
    id: null,
  });
  const [isDragging, setIsDragging] = useState(false);

  const [addImagenGaleriaEmpresa] = useMutation(ADD_IMAGEN_GALERIA_EMPRESA);
  const [deleteImagenGaleriaEmpresa] = useMutation(
    DELETE_IMAGEN_GALERIA_EMPRESA
  );

  const handleClose = () => {
    setShowModal(false);
    setShowImg(null);
    setSelectedFiles([]);
    setPreviewImages([]);
  };
  const handleShow = () => setShowModal(true);
  const handleCloseModShowImg = () =>
    setModShowImg({ img: "", open: false, isOld: false });
  const handleCloseModDelete = () => setModDelete(false);
  const handleShowModDelete = () => setModDelete(true);

  const handleFiles = useCallback((files) => {
    const imageFiles = Array.from(files).filter(file => file.type.startsWith('image/'));
    if (imageFiles.length === 0) return;
    
    const newPreviews = imageFiles.map(file => URL.createObjectURL(file));
    setSelectedFiles(prev => [...prev, ...imageFiles]);
    setPreviewImages(prev => [...prev, ...newPreviews]);
  }, []);

  useEffect(() => {
    const handlePaste = (e) => {
      if (!showModal) return;
      const items = e.clipboardData?.items;
      if (!items) return;
      
      const imageFiles = [];
      for (let item of items) {
        if (item.type.startsWith('image/')) {
          imageFiles.push(item.getAsFile());
        }
      }
      
      if (imageFiles.length > 0) {
        e.preventDefault();
        handleFiles(imageFiles);
      }
    };

    window.addEventListener("paste", handlePaste);
    return () => window.removeEventListener("paste", handlePaste);
  }, [showModal, handleFiles]);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    handleFiles(e.dataTransfer.files);
  };

  const selectFile = (event) => {
    handleFiles(event.target.files);
  };

  const removeImage = (index) => {
    const newFiles = [...selectedFiles];
    const newPreviews = [...previewImages];
    newFiles.splice(index, 1);
    newPreviews.splice(index, 1);
    setSelectedFiles(newFiles);
    setPreviewImages(newPreviews);
  };

  const saveImage = async () => {
    if (selectedFiles.length === 0) {
      let txtArea = document.getElementById("formImageInput");
      if (txtArea) txtArea.className = "form-control is-invalid";
      return;
    }

    setBtnDisabled(true);
    setLdAccion(true);

    try {
      for (const file of selectedFiles) {
        const res = await uploadImgS3({
          data: file,
          filename: file.name || "added_image.png",
          prefix: "galeria",
        });
        await addImagenGaleriaEmpresa({
          variables: {
            nombre_imagen: res?.key,
            empresa_id,
          },
        });
      }
      refetch();
      setComplet(true);
    } catch (error) {
      console.error("Error uploading images:", error);
    }

    setBtnDisabled(false);
    setLdAccion(false);
    setTimeout(() => {
      setComplet(false);
      setShowImg(null);
      setSelectedFiles([]);
      setPreviewImages([]);
      setShowModal(false);
    }, 1000);
  };

  const toImageURL = ({ nameFile, isOld }) => {
    const folderTest = process.env.REACT_APP_AWS_S3_FOLDER_TEST
      ? process.env.REACT_APP_AWS_S3_FOLDER_TEST
      : "";
    if (isOld) {
      return `${process.env.REACT_APP_AWS_S3_URL}/galeria${folderTest}/${nameFile}`;
    }
    return `${
      process.env.REACT_APP_AWS_S3_URL
    }/galeria${folderTest}/${trimLastKey(nameFile)}`;
  };

  const handleClicShowModImg = ({ nombre_descargar, isOld }) => {
    setModShowImg({ img: nombre_descargar, open: true, isOld });
  };

  const handleClickSetElement = (value) => {
    handleShowModDelete();
    setselectedElement(value);
  };

  const handleDeletElement = async () => {
    setLdAccion(true);
    const {
      data: { deleteImagenGaleriaEmpresa: result },
    } = await deleteImagenGaleriaEmpresa({
      variables: { id: selectedElement.id },
    });
    if (parseInt(result.id) > 0) {
      refetch();
    }
    setLdAccion(false);
    setComplet(true);
    setTimeout(() => {
      setComplet(false);
      setModDelete(false);
    }, 1000);
  };

  if (loading) return <LoadingPage />;
  if (error) return <Errors error={error} />;
  if (!data.galeria_empresa) return "No existe informacion";

  return (
    <>
      <h5 className="">Galería de Imagenes</h5>

      <div className="mb-2">
        <Button className="btn-primary me-2" size="sm" onClick={handleShow}>
          <i className="fa fa-plus"></i> Agregar Imagen
        </Button>
      </div>

      {loading ? (
        <div>
          <td>Cargando...</td>
        </div>
      ) : (
        <Row className="justify-content-md-center" style={{ gap: "10px 0" }}>
          {data.galeria_empresa.length === 0 ? (
            <ContainerNotResult
              icon="fa fa-search"
              mensaje="No hay im&aacute;genes a&uacute;n."
            >
              <Button
                variant="outline-primary"
                className="mt-3"
                onClick={handleShow}
              >
                Agregar Imagen
              </Button>
            </ContainerNotResult>
          ) : (
            _.map(data.galeria_empresa, (value, key) => {
              return (
                <Col
                  key={key}
                  xs={6}
                  md={4}
                  lg={3}
                  style={{ position: "relative" }}
                  onMouseOver={() => setHover({ visible: true, id: value.id })}
                  onMouseLeave={() => setHover({ visible: false, id: null })}
                >
                  <S3Image
                    key={key}
                    src={value.nombre_descargar}
                    folder="galeria"
                    alt="Imagen de galería"
                    width={200}
                    height={200}
                    style={{ objectFit: "cover", cursor: "pointer" }}
                    onClick={() => {
                      handleClicShowModImg({
                        nombre_descargar: value.nombre_descargar,
                        isOld: moment(value.fecha).isBefore(
                          moment("2024-08-15")
                        ),
                      });
                    }}
                  />
                  {isHovered.visible && isHovered.id === value.id && (
                    <Button
                      size="sm"
                      style={{
                        position: "absolute",
                        bottom: "10px",
                        right: "10px",
                      }}
                      variant="danger"
                      onClick={() => handleClickSetElement(value)}
                    >
                      <i className="fas fa-trash"></i>
                    </Button>
                  )}
                </Col>
              );
            })
          )}
        </Row>
      )}

      <Modal show={showModal} onHide={handleClose} backdrop="static" size="lg">
        <Modal.Body className="px-4 pt-4 pb-0">
          <Form.Group>
            <div
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              style={{
                border: isDragging ? "3px dashed #0d6efd" : "3px dashed #dee2e6",
                borderRadius: "8px",
                padding: "20px",
                textAlign: "center",
                backgroundColor: isDragging ? "#f8f9fa" : "transparent",
                transition: "all 0.2s ease",
                minHeight: "150px",
              }}
            >
              {previewImages.length > 0 ? (
                <Row className="mb-3">
                  {previewImages.map((preview, index) => (
                    <Col xs={4} key={index} className="mb-2 position-relative">
                      <img
                        src={preview}
                        alt={`Preview ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "4px",
                        }}
                      />
                      <Button
                        variant="danger"
                        size="sm"
                        style={{
                          position: "absolute",
                          top: "2px",
                          right: "2px",
                          padding: "2px 6px",
                          lineHeight: 1,
                        }}
                        onClick={() => removeImage(index)}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </Col>
                  ))}
                </Row>
              ) : null}

              {previewImages.length > 0 && (
                <div className="mb-3" style={{ fontSize: "13px", color: "#6c757d" }}>
                  {selectedFiles.length} imagen(es) seleccionada(s)
                </div>
              )}

              <Form.Label
                className="btn btn-outline-primary"
                style={{ marginBottom: "0px" }}
              >
                <Form.Control
                  type="file"
                  accept="image/*"
                  multiple
                  style={{ display: "none" }}
                  onChange={selectFile}
                  id="imagenesFiles"
                />
                <i className="fas fa-plus"></i> Seleccionar Imágenes
              </Form.Label>

              <p className="mt-2 mb-0" style={{ fontSize: "12px", color: "#adb5bd" }}>
                Arrastra imágenes aquí o pépalas (Ctrl+V)
              </p>
            </div>
          </Form.Group>
          {ldAccion ? <Alert variant="success">Cargando...</Alert> : ""}
          {complet ? (
            <Alert variant="success">Cargadas Correctamente.</Alert>
          ) : (
            ""
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Salir
          </Button>
          <Button variant="primary" disabled={btnDisabled || selectedFiles.length === 0} onClick={saveImage}>
            Guardar {selectedFiles.length > 0 ? `(${selectedFiles.length})` : ""}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modDelete}
        onHide={handleCloseModDelete}
        backdrop="static"
        size="md"
      >
        <Modal.Body className="p-4">
          <div>Se Necesita Confirmaci&oacute;n Para Eliminar.</div>
          {ldAccion ? <Alert variant="success">Cargando...</Alert> : ""}
          {complet ? (
            <Alert variant="success">Eliminado Correctamente.</Alert>
          ) : (
            ""
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModDelete}>
            Salir
          </Button>
          <Button variant="primary" onClick={handleDeletElement}>
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modShowImg.open}
        onHide={handleCloseModShowImg}
        size="lg"
        centered
        contentClassName="bg-transparent border-0"
      >
        <Modal.Body className="p-0 m-0 text-center">
          <S3Image
            src={modShowImg.img}
            folder="galeria"
            alt="Imagen de galería"
            style={{ maxWidth: "600px" }}
            onClick={handleCloseModShowImg}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GaleriaDeImagenes;
